import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { HeaderContainer, LogoContainer, NavContainer, HamburgerMenu } from './Header.styled';

function Header() {
    const [isNavActive, setIsNavActive] = useState(false);
    const location = useLocation();

    useEffect(() => {
        setIsNavActive(false);
    }, [location.pathname]);

    const toggleNav = () => {
        setIsNavActive(!isNavActive);
    };

    return (
        <HeaderContainer>
            <LogoContainer>
                <Link to="/">
                    <img
                        src="/img/LogoDuoaColor.png"
                        alt="DuoaColor Logo"
                    />
                </Link>
            </LogoContainer>
            <NavContainer className={isNavActive ? 'active' : ''}>
                <ul>
                    <li><Link to="/">El Inicio</Link></li>
                    <li><Link to="/our-essence">Nuestra Esencia</Link></li>
                    <li><Link to="/create-your-story">Crea Tu Historia</Link></li>
                    <li><Link to="/lived-stories">Historias Vividas</Link></li>
                    <li><Link to="/listos-para-ti">Listos para Ti</Link></li>
                    <li><Link to="/contact">Hablemos</Link></li>
                </ul>
            </NavContainer>
            <HamburgerMenu onClick={toggleNav}>
                <div></div>
                <div></div>
                <div></div>
            </HamburgerMenu>
        </HeaderContainer>
    );
}

export default Header;